/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseReferentialCategory } from '../../models/api-response-referential-category';
import { ReferentialCategory } from '../../models/referential-category';

export interface CreateReferentialCategory$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: ReferentialCategory
}

export function createReferentialCategory(http: HttpClient, rootUrl: string, params: CreateReferentialCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialCategory>> {
  const rb = new RequestBuilder(rootUrl, createReferentialCategory.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseReferentialCategory>;
    })
  );
}

createReferentialCategory.PATH = '/v1/api/ui/referential/category';
